import {useTranslation} from "react-i18next";
import useModal from "../../../../Hooks/useModal";
import {useState} from "react";
import Modals from "../../../../Constants/modals";
import {VossProductGroupType} from "../../../../Constants/VOSS/vossProductGroupType";
import helpers from "../../../../Utils/helpers";
import {SkynetAnchor} from "../../../../Components/Fundamentals/Anchor/SkynetAnchor";
import ProductGroupTerminationModal from "../../../../Components/Modals/ProductGroupTermination/ProductGroupTerminationModal";

export const ProductGroups = ({ productGroups, subscription, blockEdit }) => {
    const { t } = useTranslation();
    const { isModalOpen, openModal } = useModal();
    const [selectedProductGroup, setSelectedProductGroup] = useState(null);

    if (!productGroups) return null;

    const onTerminate = (productGroup) => {
        setSelectedProductGroup(productGroup);
        openModal(Modals.ProductGroupTermination);
    }

    let optionalProductGroups = productGroups.filter(x => x.productGroupType == VossProductGroupType.Optional)
    let includedProductGroups = productGroups.filter(x => x.productGroupType == VossProductGroupType.Included)

    return <>
        <div>
            <h3>{t('subscriptions.optionalProducts')}</h3>
            <table className="table table-stripe skynet-table-no-divider mb-0">
                <thead>
                <tr>
                    <th colSpan={1}>{t('common.name')}</th>
                    <th colSpan={1}>{t('activesubscriptionproductgroups.startdate')}</th>
                    <th className="col-5"></th>
                </tr>
                </thead>
                <tbody>
                {optionalProductGroups.length > 0 ? (
                    optionalProductGroups.map((productGroup) => (
                        <tr key={productGroup.id}>
                            <td>{productGroup.name}</td>
                            <td>{helpers.formatDate(productGroup.created)}</td>
                            <td width={200} className="text-center">
                                {!productGroup.termination && <SkynetAnchor disabled={blockEdit} onClick={() => onTerminate(productGroup)}>{t('activesubscriptionproductgroups.terminateproductgroup')}</SkynetAnchor>}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={7}>
                            <em>{t('activesubscriptionproductgroups.noactiveproductgroups')}</em>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
            <h3 className="mt-24">{t('subscriptions.includedProducts')}</h3>
            <table className="table table-stripe skynet-table-no-divider mb-0 mt-24">
                <thead>
                <tr>
                    <th colSpan={1}>{t('common.name')}</th>
                    <th colSpan={1}>{t('activesubscriptionproductgroups.startdate')}</th>
                    <th className="col-5"></th>
                </tr>
                </thead>
                <tbody>
                {includedProductGroups.length > 0 ? (
                    includedProductGroups.map((productGroup) => (
                        <tr key={productGroup.id}>
                            <td>{productGroup.name}</td>
                            <td>{helpers.formatDate(productGroup.created)}</td>
                            <td width={200} className="text-center">
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={7}>
                            <em>{t('activesubscriptionproductgroups.noactiveproductgroups')}</em>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
        {isModalOpen(Modals.ProductGroupTermination) && (
            <ProductGroupTerminationModal subscription={subscription} productGroup={selectedProductGroup} />
        )}
    </>
}